export default __webpack_public_path__ + "static/media/gob_about_slide_4.93703f12.png";